import domain_checker from '../photos/Domain_Checker.jpg';
import empty_image from '../photos/empty-images.avif'
import { FaCss3Alt, FaHtml5 } from 'react-icons/fa';

let certificate;
export default certificate = [
    {
        title: "",
        description: "",
        image: empty_image,
        tools: [],
        icons: [],
        github: "",
        live: ""
    }
]